<script setup lang="ts">
// The closing navy band — mockup page 1, above the footer. Last chance to
// send the visitor into the assessment, with the three things they get out
// of it spelled out beside the button.
import { RouterLink } from 'vue-router'

const PROMISES = [
    'Understand the problem',
    'Compare repair vs. replacement',
    'Get a local HVAC recommendation',
]
</script>

<template>
    <section class="closing">
        <div class="inner">
            <div class="copy">
                <h2>Not Sure What's Wrong<br />With Your AC?</h2>
                <p class="lead">Ask the HVAC Expert —</p>
                <p class="sub">Get clarity. Get options. Get peace of mind.</p>
            </div>

            <div class="action">
                <RouterLink class="cta" to="/ask">Start Your Assessment →</RouterLink>
                <p class="fine">It only takes a few minutes.</p>
            </div>

            <ul class="promises">
                <li v-for="p in PROMISES" :key="p">✓ {{ p }}</li>
            </ul>
        </div>
    </section>
</template>

<style scoped lang="scss">
.closing {
    background: var(--site-gradient-navy);
    color: #fff;
}

.inner {
    max-width: var(--site-content-max);
    margin: 0 auto;
    padding: var(--site-xl, var(--site-space-xl)) var(--site-space-lg);
    padding-top: var(--site-space-xl);
    padding-bottom: var(--site-space-xl);
    display: grid;
    grid-template-columns: 1.2fr auto 1fr;
    align-items: center;
    gap: var(--site-space-xl);

    @media (max-width: 940px) {
        grid-template-columns: 1fr;
        gap: var(--site-space-lg);
        text-align: center;
        justify-items: center;
    }
}

h2 {
    font-family: var(--site-font-heading);
    font-size: clamp(1.4rem, 2.6vw, 2rem);
    font-weight: 800;
    margin: 0 0 0.4rem;
    line-height: 1.2;
}

.lead {
    margin: 0;
    font-weight: 700;
    color: #ffb489;
}

.sub {
    margin: 0.1rem 0 0;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.8);
}

.cta {
    display: inline-block;
    padding: 0.85rem 1.6rem;
    border-radius: var(--site-radius-pill);
    background: var(--site-gradient-cta);
    color: #fff;
    font-family: var(--site-font-heading);
    font-size: 1.02rem;
    font-weight: 700;
    text-decoration: none;
    box-shadow: var(--site-glow);
    white-space: nowrap;

    &:hover {
        background: var(--site-accent-strong);
    }

    /* 48px so a primary CTA is never the hardest thing on the page to
       hit. Mobile only — desktop keeps its tighter proportions. */
    @media (max-width: 860px) {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 48px;
    }
}

.fine {
    margin: 0.45rem 0 0;
    font-size: 0.74rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.72);
}

.promises {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    font-size: 0.86rem;
    color: rgba(255, 255, 255, 0.9);
}
</style>
